'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JacketViewButton = function JacketViewButton(_ref) {
  var currentView = _ref.currentView,
      toggleListView = _ref.toggleListView,
      className = _ref.className;

  var isActive = currentView === 'medium' ? 'active' : '';
  var toggleView = function toggleView() {
    return toggleListView('medium');
  };

  var btnClasses = (0, _classnames2.default)(className, { active: currentView === 'medium' });

  return _react2.default.createElement(
    _reactIntl.FormattedMessage,
    { id: 'jacket_view', values: { isActive: isActive ? 'yes' : 'no' } },
    function (message) {
      return _react2.default.createElement(
        _baseButtons.DefaultButton,
        { 'data-test-id': 'jacket-view-button', flat: true, className: btnClasses, handleClick: toggleView, title: message },
        _react2.default.createElement(_baseIcons.JacketView, null),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          message
        )
      );
    }
  );
};

JacketViewButton.propTypes = {
  className: _react.PropTypes.string,
  currentView: _react.PropTypes.string.isRequired,
  toggleListView: _react.PropTypes.func.isRequired
};

exports.default = JacketViewButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-jacket-view-button/lib/components/JacketViewButton.component.js
// module id = 1328
// module chunks = 1